import { render } from "./Notifications.vue?vue&type=template&id=43a3e4e8"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43a3e4e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43a3e4e8', __exports__)) {
    api.reload('43a3e4e8', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=43a3e4e8", () => {
    api.rerender('43a3e4e8', render)
  })

}


export default __exports__